import PageHero from '@/components/feature/PageHero';
import { techHero } from '@/mocks/tech';

export default function Hero() {
  return (
    <PageHero
      eyebrow={techHero.eyebrow}
      title={techHero.title}
      desc={techHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20futuristic%20digital%20operating%20system%20visualization%20with%20glowing%20circuit%20network%20nodes%20and%20flowing%20data%20streams%2C%20deep%20ink%20navy%20background%2C%20eco%20green%20and%20gold%20accent%20particles%2C%20hexagonal%20connection%20lines%20forming%20a%20central%20hub%2C%20minimal%20clean%20cinematic%20composition%2C%20national%20strategy%20technology%20aesthetic&width=1800&height=1200&seq=tech-hero-01&orientation=landscape"
      imageAlt="华辉数智三大核心技术能力数字基础设施"
      imageTitle="华辉数智技术 核心技术能力"
    />
  );
}